import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import GameModel from "../core/model/GameModel";
import DialogSceneView from "../ngt/dialog/view/DialogSceneView";
import AbstractCollaborationScreenMediator from "../core/view/AbstractCollaborationScreenMediator";

export default class TransitionScreenMediator extends AbstractCollaborationScreenMediator {

    /**
     * 
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {*} gameAssets 
     * @param {AppModel} appModel 
     * @param {GameModel} gameModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel, gameConfig, dialogSceneAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel);
        this._gameConfig = gameConfig;
        this._dialogSceneAssets = dialogSceneAssets;
    }

    initialize() {
        super.initialize();

        const { dialogID, onClose } = this._target.parameters;
        this._onClose = onClose;

        const prefix = `transitions.${dialogID}.`;
        this._target.titleTextfield.text = this.getText(prefix + "title");
        this._target.bodyTextfield.text = this.getText(prefix + "body");

        this._button = this.createButton(this._target.button, this._handleButtonClick.bind(this), this.getText("transitions.button"));

        this._first = !this._gameModel.restoredFeedbackPending && this._gameModel.isFirst(dialogID) && getURLParameter("skipbios") != "1";
        if (this._first) {       
            this.addInfoPanel();         
            this.callDelayed(() => { 
                this._infoPanel.forceReadAll();
                this._infoPanel.open(); 
            }, 300);
            this._button.setVisible(false);
        }

        this.anchorObject(this._button.skin, Anchor.B);

        this._autoStart = this._gameConfig.getValue("transition.autostart");

        this._elementsToAnimate = [
            this._target.titleTextfield,
            this._target.bodyTextfield
        ];

        if (this._autoStart) {
            this._button.setVisible(false);
        } else {
            this._elementsToAnimate.push(this._button.target);
        }
        this._elementsToAnimate.forEach(elem => elem.alpha = 0);

        if (!this._first) {
            this._handleInfoPanelClose();
        }

        this.checkSavegameRestoredFeedback(-300);
    }

    destroy() {
        super.destroy();
        document.body.removeEventListener("click", this._onClose);
    }

    _animateIn() {
        let delay = 0;
        this._elementsToAnimate.forEach(elem => {
            elem.visible = true;
            createjs.Tween.get(elem)
                .wait((delay += 100) / this._speedFactor)
                .to({ alpha: 1 }, 500 / this._speedFactor, createjs.Ease.quadOut);
        });
    }

    _animateOut() {
        const dur = 500;
        let delay = 0;
        this._elementsToAnimate.forEach(elem => {
            createjs.Tween.get(elem)
                .wait((delay += 100) / this._speedFactor)
                .to({ alpha: 0 }, dur / this._speedFactor, createjs.Ease.quadIn);
        });
        this.callDelayed(this._onClose.bind(this), (delay + dur + 300) / this._speedFactor);
    }

    _handleButtonClick(e) {
        this._button.setEnabled(false);
        this._onClose();
    }

    _handleInfoPanelClose(e) {
        const delay = this._first ? 1000 : 0;
        this.callDelayed(() => { this._animateIn(); }, delay / this._speedFactor);

        if (this._autoStart) {
            this._onClose = this._onClose.bind(this);
            //call with 1 frame delay, so listeners is not called right away:
            this.callDelayed(() => { document.body.addEventListener("click", this._onClose); });

            const startDelay = this._gameConfig.getValue("transition.duration");
            this.callDelayed(() => { this._animateOut(); }, (delay + startDelay) / this._speedFactor);
        }

        this._first = false;
    }

    _handleInfoPanelOpen(e) {
        this._button.setVisible(false);
    }
}
